import React, { Component } from 'react'
//import NameReferralForm from './FamilyReferralNew.jsx'
//import { FamilyReferralForm } from './FamilyReferralForm.jsx'
import { combineNames, ModalReferral, FamilyReferralStatusOptions, 
    getFamilyReferralStatusOptions, emptyReferral, ResetEmptyReferral } from './FamilyReferralHelpers.jsx'
//import Modal from '../../components/Modal/Modal'
import YSpinner from '../../elements/Spinner/Spinner'
import { ReferralsEP, GetRnamesEPmbo /*, HostUrl instance*/ } from '../../variables/Config'

class ReferralNames extends Component {
    constructor(props) {
        super(props);
        this.state = { showme: false, family:[], familyLoading: false }
    }

    fetchFamily = (id) => {
        let url = ReferralsEP() + '/' + id
        this.setState({familyLoading:true})
        fetch(url)
            .then(response => {
                if (response.ok) {
                    //if (!this._isMounted) return null
                    return response.json()
                } else
                    throw new Error('fetchFamily: Something went wrong ... ')
            })
            .then(family => {
                /*rlist.sort(function (a, b) {
                    if (a['f'] > b['f'])
                        return 1
                    if (a['f'] < b['f'])
                        return -1
                    return 0
                })*/
                //if (!this._isMounted) return null
                this.setState({ family: family['acf'], familyLoading: false })
                return family['acf']; // void - no one is looking...
            })
            .catch(restError => this.setState({ restError: restError, familyLoading: false }))
    }
    handleShow = (ev, mykey) => {
        ev.preventDefault()
        this.fetchFamily(mykey)
        this.props.curFamily(mykey) // tell parent which is current family
        this.setState({ showme: true })
    }
    handleHide = (ev) => {
        ev.preventDefault()
        this.setState({ showme: false })
    }
    render() {
        const { referral, mykey, active, addReferralIntoList, removeReferral } = this.props;

        if (this.state.showme && !this.state.familyLoading){
           // if (this.state.familyLoading)
           //     return (<YSpinner />)
            return (
                <ModalReferral 
                    referral={this.state.family} 
                    title="עדכון הפניה" 
                    // addReferral={addReferral} 
                    addReferralIntoList = {addReferralIntoList}
                    removeReferral={removeReferral} 
                    newRF ={false} 
                    closeModal = {this.handleHide} 
                    mbouser = {this.props.mbouser}
                />
            )
        } else {
            if (referral === undefined) {
                console.log("Referrali ERROR - referral undfefined")
                return (<div key={mykey} className="referral-i"  onClick={(event) => this.handleShow(event, mykey)}>undefined</div>)
            }
            let family = referral['f'] === undefined ? 'משפחה חסר' : referral['f']
            let woman = referral['w'] === undefined ? 'אשה חסר' : referral['w']
            let man = referral['m'] === undefined ? 'גבר חסר' : referral['m']
            let status = referral['s'] === undefined ? 'סטטוס חסר' : referral['s']
            let fclass = active === mykey ? "referral-i active" : "referral-i"
            
            return (<div key={mykey} className={fclass} onClick={(event) => this.handleShow(event, mykey)}>
                {combineNames(family, woman, man, status)}
            </div>)
        }
    }
}

// main referral index component
// gets the data & use components to display it
class FamilyReferralBody extends Component {
    constructor(props) {
        super(props)
        this._isMounted = false

        this.state = {
            rlist: [],
            referrals: [], restError: "",
            filter: "", filterbystatus: "",
            active: "",
            showModal: false, 
            isLoadingR: true
        }
        // this.addReferral = this.addReferral.bind(this)
        this.addReferralIntoList = this.addReferralIntoList.bind(this)
    }
    currentFamily = (x) => {
        this.setState({active: x})
    }
    handleNewShow = (ev) => {
        ev.preventDefault() 
        ResetEmptyReferral(emptyReferral) // ["family_referral_family_name"] = ""  
        this.setState({ showModal: true })
    }
    
    handleHide = (ev) => {
        ev.preventDefault()
        this.setState({ showModal: false })
    }
    /* for rnames list */
    newFetch = (url) => {
        fetch(url/*,{headers: {'Cache-Control' : 'private'}}*/)
            .then(response => {
                if (response.ok) {
                    if (!this._isMounted) return null
                    return response.json()
                } else
                    throw new Error('newFetch: Something went wrong ... ')
            })
            .then(rlist => {
                /*rlist.sort(function (a, b) {
                    if (a['f'] > b['f'])
                        return 1
                    if (a['f'] < b['f'])
                        return -1
                    return 0
                })*/
                if (!this._isMounted) return null
                this.setState({ rlist, isLoadingR: false })
                return rlist; // void - no one is looking...
            })
            .catch(restError => this.setState({ restError: restError, isLoadingR: false }))
    }
    
    componentDidMount() {
        this._isMounted =true
        this.newFetch(GetRnamesEPmbo) // "https://d.w2go.co.il/wp-json/mbo/v3/getRnames"
    }
    componentWillUnmount(){
        this._isMounted = false
    }
    filter = (e) => {
        e.preventDefault()
        this.setState({ filter: e.target.value })
    }
    // if filter by status - emptyfilter by name
    filterbystatus = (e) => {
        e.preventDefault()
        this.setState({ filterbystatus: e.target.value })
    }

    removeReferral = (pid) => {
        //let allReferrals = Object.assign(this.state.referrals)
        let allReferrals = Object.assign(this.state.rlist)
        let i = 0
        while (i < allReferrals.length && allReferrals[i]['id'] !== parseInt(pid, 10)) i++
        if (i >= allReferrals.length){
            console.log("INTERNAL ERROR removeReferral - could not find referral object", pid)
            return false
        }
        allReferrals.splice( i, 1) // remove            
        this.setState({ rlist: allReferrals, showModal:false }) // update this.state.showModal
        //this.setState({ referrals: allReferrals, showModal:false }) // update this.state.showModal
        return true
    }

    // addReferral is called for new or update referral
    addReferralIntoList = (updatedFamily, newrf) => {
        updatedFamily['family_referral_code'] = parseInt(updatedFamily['family_referral_code'])
        updatedFamily['family_referral_family_code'] = parseInt(updatedFamily['family_referral_family_code'])
          
        if (!newrf){
            let newrlist = [...this.state.rlist]
            for (let i = 0; i < newrlist.length; i++){
                if (newrlist[i]['id'] === updatedFamily['family_referral_code']){
                    newrlist[i]['f'] =  updatedFamily['family_referral_family_name'];
                    newrlist[i]['w'] =  updatedFamily['family_referral_woman_firstname'];
                    newrlist[i]['m'] =  updatedFamily['family_referral_man_firstname'];
                    newrlist[i]['s'] =  updatedFamily['family_referral_status'];
                    break;
                }
            }
            this.setState({ rlist: newrlist })

            //console.log('addReferralIntoList', updatedFamily)
            return parseInt(updatedFamily['family_referral_code'])
        }
        let newFobj = {
            id: updatedFamily['family_referral_code'],
            f: updatedFamily['family_referral_family_name'],
            w: updatedFamily['family_referral_woman_firstname'],
            m: updatedFamily['family_referral_man_firstname'],
            s: updatedFamily['family_referral_status'],
        }
        let allReferrals = [newFobj, ...this.state.rlist]
        // this.sortRlist(allReferrals) - not in use
        this.setState({ rlist: allReferrals })
        return updatedFamily['family_referral_code']
      }
      /*
    sortRlist = (allReferrals) => {
         // sort
        allReferrals.sort(function (a,b) {
            if (a['f'] > b['f'])
                return 1
            if (a['f'] < b['f'])
                return -1
            return 0
        })
        return allReferrals
    }*/
    newReferralModal = () => {
        const modal = this.state.showModal ? (
            <ModalReferral 
                referral={emptyReferral} 
                title="הפניה חדשה" 
                // addReferral={this.addReferral}
                addReferralIntoList = {this.addReferralIntoList} 
                removeReferral={this.removeReferral} 
                newRF ={true} 
                closeModal = {this.handleHide} 
                mbouser = {this.props.mbouser}
                />
        ) : null
        return modal 
    }
    render() {
        const {filter, filterbystatus, restError, rlist, isLoadingR} = this.state 
        if (restError !== "")
            return <h2>{restError} לא נמצאו הפניות</h2>

        //    if (isLoading || isLoadingR)
        if (isLoadingR)
            return (<YSpinner />)

        //let items = Object.assign(referrals) // IMMUTABILITY- fixed
        //console.log('rlist = ', this.state.rlist)
        
        let items = Object.assign(rlist) // IMMUTABILITY- fixed
        if (filter) {
            items = items.filter(item =>
                item['f'].includes(filter) || item['w'].includes(filter) || item['m'].includes(filter))
        }
        if (filterbystatus) {
            if ("לא מוגדר" === filterbystatus){
                let status_list = getFamilyReferralStatusOptions()
                items = items.filter(item => !status_list.includes(item['s']))
            } else
                items = items.filter(item => item['s'].includes(filterbystatus))
        }
        return (
            <div id="main-win">
                <h3 className="table-header">אינדקס הפניות ({items.length})</h3>

                <div className="yahav-index-families" >
                    <button onClick={this.handleNewShow}>הפניה חדשה</button>
                    {this.newReferralModal() }
                    
                    <span>&nbsp;&nbsp;</span>
                    <input id="filter-by-name" type="text" value={filter} 
                                    onChange={this.filter} placeholder="חיפוש לפי שם..." />
                    <span>&nbsp;&nbsp;</span>
                    <select onChange={this.filterbystatus}  >
                        <option value="" >סטטוס:  כל המשפחות</option>
                        <FamilyReferralStatusOptions />
                    </select>
                    <br /><br />
                    <div className="yahav-index-families-items" >
                        {items.length === 0 ? <h3>לא נמצאו הפניות, נסי חיפוש אחר</h3>
                            : items.map((item, index) => {
                                // console.log("Referrali id=", item['acf'] )
                                let key = item['id']
                                return(
                                    <ReferralNames key={index} mykey={key} referral={item} 
                                        // addReferral={this.addReferral} 
                                        addReferralIntoList = {this.addReferralIntoList} 
                                        removeReferral={this.removeReferral} 
                                        newRF={true}
                                        curFamily = {this.currentFamily}
                                        active = {this.state.active}
                                        mbouser = {this.props.mbouser} />
                                    )
                            }, this)
                        }
                    </div>
                </div>
            </div>
        )
    }
}
class FamilyReferralIndex extends React.PureComponent {
    render() {
        return (
            <div>
                <div id="modal-root"></div>
                <FamilyReferralBody {...this.props} />
            </div>
        )
    }
}
export default FamilyReferralIndex;
